import {observer} from "mobx-react";
import {useState} from "react";
//import {AccordionComponentBox} from "./boxes/accordion-component.box";
import {AccordionContentComponent} from "./components/content/accordion-content.component";
import {AccordionHeaderComponent} from "./components/header/accordion-header.component";

interface AccordionProps {
    title?: React.ReactElement;
    isTitleCentered: boolean;
    content: React.ReactElement;
    onExpandChange?: (isExpanded: boolean) => void;
}
export const AccordionComponent: React.FC<AccordionProps> = observer((props) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        const newState = !isExpanded;
        setIsExpanded(newState);
        props.onExpandChange?.(newState);
      };

    return (
        <>
            <AccordionHeaderComponent
                title={props.title}
                isOpen={isExpanded }
                isTitleCentered={props.isTitleCentered}
                toggleIsOpen={toggleExpand}
            />
            <AccordionContentComponent content={props.content} isOpen={isExpanded} />
        </>
    )
})